/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Fire_TitleInputs */

const en_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fire`)
};

const ar_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النار`)
};

const de_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feuer`)
};

const es_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuego`)
};

const fr_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feu`)
};

const it_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuoco`)
};

const ja_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`炎`)
};

const ko_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`불`)
};

const pt_br_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fogo`)
};

const ru_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огонь`)
};

const th_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟ`)
};

const tr_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ateş`)
};

const zh_cn_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`火`)
};

const zh_tw_daily_paywall_exclusive_tree_fire_title = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`火`)
};

/**
* | output |
* | --- |
* | "Fire" |
*
* @param {Daily_Paywall_Exclusive_Tree_Fire_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_fire_title = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Fire_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Fire_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_fire_title(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_fire_title(inputs)
	return zh_tw_daily_paywall_exclusive_tree_fire_title(inputs)
});